import React from 'react'
import UpsalePreviewImage from './upsale-preview-image'
import createReactClass from 'create-react-class'


var UpsalePreviewImages = createReactClass({

  render: function() {
    var imageList = [],
        imagesClassName = '';
    for (var i = 0; i < this.props.itemList.length; i++) {
      if (i > 2) {
        break;
      }
      imageList.push(<UpsalePreviewImage item={this.props.itemList[i]} imageId={this.props.itemList[i].getImageId()} key={this.props.itemList[i].getId()} />);
    }

    // Add classes for showing active upsale options
    if(this.props.itemList[0].hasOptionByName('border')) {
      imagesClassName += ' white-border';
    }
    if(this.props.itemList[0].hasOptionByName('glossy')) {
      imagesClassName += ' glossy';
    }

    return (
      <div className={"ope-upsale__group__images" + imagesClassName}>
          {imageList}
      </div>
    );
  }
});

export default UpsalePreviewImages;
